import axios from '@/components/api/axios';

async function getLimitDateList() {
  let data = {
    bcNo: localStorage.getItem('limitDateNowBC')
  }
  const res = await axios.axiosGet('/api/limitDates', data);
  return res;
}

export default {
  getLimitDateList
}



// WEBPACK FOOTER //
// ./src/components/api/limitDate.js